module.exports = __webpack_public_path__ + "static/media/laptop.094a3b64.png";